module.exports = __webpack_public_path__ + "img/tradeCenter.e40706ce.png";